export * from './lib/helpers';
export * from './lib/animations';
export * from './lib/track-by';
export * from './lib/rxjs-helpers';
export * from './lib/scroll';
export * from './lib/interfaces';
export * from './lib/types';
export * from './lib/regex-patterns';
export * from './lib/ng-locales';

export * from './lib/detached-router/detached-router-outlet/detached-router-outlet.component';
export * from './lib/link-anchor-wrapper';

export * from './lib/exif.interfaces';
export * from './lib/tokens';
export * from './lib/noop-zone';

export * from './lib/tokens/window-resize-token';
export * from './lib/tokens/navigator';

export * from './lib/validators/date-validator';
export * from './lib/validators/url-validator';
export * from './lib/validators/soft-url-validator';
export * from './lib/validators/email-validator';
export * from './lib/validators/matching-passwords-validator';
export * from './lib/validators/subdomain-validator';
export * from './lib/validators/time-validator';
export * from './lib/validators/no-whitespace-validator';
export * from './lib/validators/inclusion-validator';
export * from './lib/validators/no-html-whitespace-validator';
export * from './lib/validators/email-local-part-validator';
export * from './lib/validators/upper-lower-case-validator';
export * from './lib/validators/domain-validator';
export * from './lib/validators/no-duplicates-validator';
export * from './lib/validators/potential-url-validator';
export * from './lib/validators/min-max-range-validator';
export * from './lib/validators/without-www-validator';
export * from './lib/validators/vat-number-required-validator';
export { isExecutableFile } from './lib/validators/file-executable-validator';
export * from './lib/validators/form-array-duplicate-validator';
export * from './lib/validators/careers-domain-validator';
export * from './lib/validators/control-uniqueness-validator';
export * from './lib/validators/phone-number-validator';
export * from './lib/validators/slug-validator';
export * from './lib/validators/work-model-validator';
export * from './lib/validators/invalid-selected-option-validator';
export * from './lib/validators/number-of-opening-validator';
export * from './lib/validators/hours-per-week-validator';
export * from './lib/validators/positive-number-validator';
export * from './lib/validators/max-editor-json-state-validator';
export * from './lib/validators/email-domain-matching-validator';

export * from './lib/errors/error-handler';
export * from './lib/errors/config';
export * from './lib/errors/error-handler.module';
export * from './lib/errors/location.service';

export * from './lib/local-storage/local-storage.service';
export * from './lib/local-storage/indexed-db.service';
export { localStorageSignal } from './lib/local-storage/local-storage-utils';
export * from './lib/form-types';

export * from './lib/services';
export * from './lib/task-scheduler.service';
export { formSignalValue, formSignalStatus } from './lib/signal';

export { WorkerFactory, WorkerPool } from './lib/worker-pool';
export { PageVisibilityService } from './lib/page-visibility.service';
export { NgTemplateAssertType, NgTemplateSwitchType } from './lib/ng-template-assert-type';

export { makeSlug } from './lib/make-slug';
export { DocumentExternalScriptsLoader } from './lib/services/document-bundles-loader';
export { RenderScheduler, injectRenderScheduler } from './lib/change-detection';
export { QueryFilterPipe } from './lib/pipes/query-filter.pipe';
export { toggleCssClass } from './lib/toggle-css-class';
// TODO bump angular to 16.2 and remove this class and export
export { RtComponentOutlet } from './lib/component-outlet.directive';
export * from './lib/ng-input';
export { ElementInjectorDirective } from './lib/element-injector.directive';
export { FnBindPipe } from './lib/pipes/fn-bind.pipe';
export { FnCallPipe } from './lib/pipes/function-call.pipe';

export { provideUrlActionTrigger } from './lib/url-action-trigger/provide-url-action-trigger';
export { provideUrlActionTriggerRoute } from './lib/url-action-trigger/provide-url-action-trigger-route';
export { UrlActionTrigger } from './lib/url-action-trigger/url-action-trigger.types';
export {
  UrlActionTriggerPipe,
  buildUrlActionTrigger,
} from './lib/url-action-trigger/url-action-trigger.pipe';
export { provide, createProviderToken, createProviderClass, TypedProvider } from './lib/provide';
export type { Providers } from './lib/provide';
export { provideComponentContract, renderComponentContract } from './lib/component-contract-utils';
export * from './lib/url-tree-utils';
